/* eslint-disable no-unreachable */
import { cn, iaRa, inRn } from 'lib/helpers/utility';

import { mergeAllRows } from '../lib/helpers';

const TableFooter = ({ columnDefs, rowData, preview, variant }) => {
  return null; // Temporarily disable footer rendering
  const lastIdx = columnDefs.length - 1;

  const data = mergeAllRows(iaRa(rowData));

  const totals = columnDefs.map((columnDefinition) => {
    if (columnDefinition.aggFunc === 'sum') {
      let columnSum = 0;
      const isDiscount = columnDefinition.field === 'discount';
      for (let rowIndex = 0; rowIndex < data.length; rowIndex++) {
        let cellValue = data[rowIndex][columnDefinition.field];
        if (
          (typeof cellValue !== 'number' || isNaN(cellValue) || !data[rowIndex].show) &&
          !isDiscount
        ) {
          cellValue = 0;
        } else if (isDiscount && typeof cellValue === 'object') {
          cellValue = inRn(cellValue?.amount_cents);
        }

        columnSum += cellValue;
      }
      if (columnDefinition.valueFormatter) {
        return columnDefinition.valueFormatter({
          value: isDiscount ? { amount_cents: columnSum } : columnSum,
          data: null,
          rowIdx: null,
          colDef: columnDefinition
        });
      }
      return columnSum;
    }
    return '';
  });

  return (
    <tr>
      {columnDefs.map((col, index) => (
        <td
          key={String(col.field)}
          className={cn(
            'border-0 border-t border-solid border-neutral-300 px-1.5 py-2 pb-3 text-sm font-semibold leading-4 text-neutral-900',
            index === lastIdx && 'w-fit justify-end text-right',
            index !== lastIdx && 'text-left',
            variant === 'primary' && 'border-primary-300'
          )}>
          {index === 0 && !preview ? 'Totals' : totals[index] !== null ? totals[index] : ''}
        </td>
      ))}
    </tr>
  );
};

export default TableFooter;
